import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useAuth } from "@clerk/react";
import { ApiClient, UnauthorizedError } from "../lib/api";
import { useEntityLabels } from "./useEntityLabels";

export function useGetPlayers() {
	const { getToken, signOut } = useAuth();
	const client = new ApiClient(getToken);

	const { set: setLabel } = useEntityLabels();

	const query = useQuery({
		queryKey: ["getPlayers"],
		queryFn: async () => {
			const response = await client.getPlayers();

			for (const player of response.players) {
				if (player.mlbStatsData?.person?.fullName) {
					setLabel(
						`player:${player.normalizedName}`,
						player.mlbStatsData.person.fullName,
					);
				}
			}

			return response;
		},
		retry: (failureCount, error) => {
			if (error instanceof UnauthorizedError) return false;
			return failureCount < 3;
		},
	});

	useEffect(() => {
		if (query.error instanceof UnauthorizedError) {
			void signOut();
		}
	}, [query.error, signOut]);

	return query;
}
